import HouseHoldMemberList from './HouseHoldMemberList';
import HouseHoldAccountOnboarding from './HouseHoldAccountOnboarding';
import { HouseholdQuestionTypes } from './questionTypes';

const withQuestionData = (question, commonConfig) => ({
	data: {
		...question,
		...commonConfig
	}
});

export const householdQuestionRenderers = {
	[HouseholdQuestionTypes.HouseHoldMemberList]: (_ctx, question, container, commonConfig) =>
		new HouseHoldMemberList(container, withQuestionData(question, commonConfig)),

	[HouseholdQuestionTypes.HouseHoldAccountOnboarding]: (_ctx, question, container, commonConfig) =>
		new HouseHoldAccountOnboarding(container, withQuestionData(question, commonConfig))
};
